"use client"
import { mediaQueries } from "@/ui/theme/mediaQueries"
import styled from "@emotion/styled"
import InvestSimulatorBlock from "../InvestSimulatorBlock/InvestSimulatorBlock"

export const StyledInvestSimulatorBlock = styled(InvestSimulatorBlock)`
  ${mediaQueries.desktop} {
    flex-direction: column;
    align-items: center;
  }
`
